export default "__VITE_ASSET__d384f55d__"